import React, { useState } from "react";
import axios from "axios";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../../../Redux/slice/features/authSlice";
import { REACT_APP_API_URL } from "../../../env";

const PasswordReset = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const { hrmsUser } = useSelector((state) => state.auth);
  const empCode = hrmsUser?.employee_id;

  const isLoggedIn = sessionStorage.getItem("hrmsLogin");
  if (!isLoggedIn) return <Navigate to="/hrms/login" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!oldPassword || !newPassword || !confirmPassword) {
      alert("Please fill in all fields.");
      return;
    }

    if (newPassword !== confirmPassword) {
      alert("New password and confirm password do not match!");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(
        `${REACT_APP_API_URL}api/hrms/auth/HRMS-reset-password`,
        {
          empCode: empCode,
          currentPassword: oldPassword,
          newPassword: newPassword,
        }
      );

      if (res.status === 200) {
        alert("Password reset successfully!");

        // Clear session and Redux state
        sessionStorage.removeItem("hrmsLogin");
        dispatch(logoutUser());

        navigate("/hrms/login", { replace: true });

        return;
      }

      alert(res.data.message || "Invalid employee ID or password.");
    } catch (err) {
      console.error("Error during password reset:", err);
      alert(
        err.response?.data?.message ||
        "An error occurred while resetting password."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="px-xl-5 px-4 auth-body">
      <form onSubmit={handleSubmit}>
        <ul className="row g-3 list-unstyled li_animate">

          <li className="col-12">
            <label className="form-label">Current Password</label>
            <div className="input-group">
              <input
                type={showOld ? "text" : "password"}
                className="form-control form-control-lg"
                placeholder="Enter current password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="btn btn-light border shadow-none"
                onClick={() => setShowOld(!showOld)}
              >
                {showOld ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
              </button>
            </div>
          </li>

          <li className="col-12">
            <label className="form-label">New Password</label>
            <div className="input-group">
              <input
                type={showNew ? "text" : "password"}
                className="form-control form-control-lg"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="btn btn-light border shadow-none"
                onClick={() => setShowNew(!showNew)}
              >
                {showNew ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
              </button>
            </div>
          </li>

          <li className="col-12">
            <label className="form-label">Confirm New Password</label>
            <div className="input-group">
              <input
                type={showConfirm ? "text" : "password"}
                className="form-control form-control-lg"
                placeholder="Re-enter new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="btn btn-light border shadow-none"
                onClick={() => setShowConfirm(!showConfirm)}
              >
                {showConfirm ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
              </button>
            </div>
          </li>

          <li className="col-12 my-lg-4">
            <button
              type="submit"
              className="btn btn-lg w-100 btn-primary text-uppercase mb-2"
              disabled={loading}
            >
              {loading ? "Please wait..." : "Reset Password"}
            </button>
          </li>

          <li className="col-12 text-center" style={{marginTop:'-10px',marginBottom:'10px'}}>
            <span className="text-primary">
              <Link style={{color:'blue'}} to="/">Back to Profile</Link>
            </span>
          </li>
        </ul>
      </form>
    </div>
  );
};

export default PasswordReset;
